<template>
    <a
        class="link"
        :href="footerLink.link" 
        :target="footerLink.target" 
    >
        {{ footerLink.title }}
    </a>
</template>

<script>
const Link = {
    props: {
        footerLink: {
            type: Object,
            require: true
        }
    },
}
export default Link;
</script>

<style scoped>
.link {
    display: inline-block;
    vertical-align: middle;
    color: #132136;
    font-size: 14px;
    line-height: 19px;
    text-decoration: underline;
    margin-right: 15px;
    word-break: break-all;
}

.link:hover,
.link:focus {
    color: #4FD892;
}

.link:active {
    opacity: .5;
}
</style>